import { useState, useEffect } from 'react'
import styles from "../../../pages/Home/ClientConfig/ClientConfig.module.css"
import * as eventManagementService from '../../../services/eventManagementService'

const GTRConfig = ({
    formData,
    GTRClientConfig,
    setGTRClientConfig,
}) => {

    const handleChange = e => {
        setGTRClientConfig({
            ...GTRClientConfig,
            [e.target.name]: e.target.value,
        })
      //  console.log(GTRClientConfig)
    }
    const [error, setError] = useState(null)
    const errorDiv = (error)
        ?
        <ul>
            {Object.entries(error).length > 0 && Object.entries(error) &&
                Object.entries(error).map(([key, value]) => {
                    return <div className={value[0] === 'Test Failure' ? styles.errorMSG : styles.successMSG} key={key} >{value}</div>;
                })}
        </ul>
        : '';
    const handleTestConnection = async e => {
        e.preventDefault()
        setError(null)
        var holder = { GTRClientConfig };
        try {
            await eventManagementService.testSetup(holder)

            //element.classList.remove("my-class");
        } catch (err) {
           // console.log(err.message)
            setError(err.internalError);
        }
    }


    const isFormValid = () => {
        return formData.ClientName
            && formData.EventRegistrationSystem
            && formData.Industry
            && formData.Categories.length > 0
            && GTRClientConfig.ApiKey
            && GTRClientConfig.Url
            ? true
            : false
    }
    const isTestFormValid = () => {
        return GTRClientConfig.ApiKey
            && GTRClientConfig.Url
            ? true
            : false
    }

    return (
        <>
            <div className={styles.inputContainer}>
                <label htmlFor="ApiKey" className={styles.label}>API Key: </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={GTRClientConfig.ApiKey}
                    name="ApiKey"
                    onChange={handleChange}
                />
            </div>

            <div className={styles.inputContainer}>
                <label htmlFor="Url" className={styles.label}>URL: </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={GTRClientConfig.Url}
                    name="Url"
                    onChange={handleChange}
                />
            </div>
            {errorDiv}
            <div className={styles.inputContainer}>
                <button disabled={!isFormValid()} className={styles.button}>
                    Submit
                </button>
                <button onClick={handleTestConnection} disabled={!isTestFormValid()} className={styles.buttonRight}>
                    Test Connection
                </button>
            </div>
           
        </>
    );
}

export default GTRConfig;